
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ManagementHero from './components/ManagementHero';
import ManagementFocus from './components/ManagementFocus';

const ManagementPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <ManagementHero />
      <ManagementFocus />
      <Footer />
    </div>
  );
};

export default ManagementPage;
